import React from 'react';
import { StyledLineSeparator } from './LineSeparator.styles.mjs';

const LineSeparator = ({ variant, margin, className }) => {
    return React.createElement(StyledLineSeparator, { variant: variant, margin: margin, className: className });
};

export { LineSeparator as default };
//# sourceMappingURL=LineSeparator.mjs.map
